import type { WizardParkingChoice } from "./PermitContextProvider/types";

export const requiresUserDateTimeInput = (choice: WizardParkingChoice): boolean => {
	const hasDateOrTimeInputsEnabled = Boolean(
		choice.time?.startDate?.enabled ||
			choice.time?.startTime?.enabled ||
			choice.time?.endDate?.enabled ||
			choice.time?.endTime?.enabled,
	);
	return hasDateOrTimeInputsEnabled && !(choice.time?.intervals?.length ?? 0);
};
